
export default class WebUSBHelpDialog {

  constructor() {
  }

  show(js) {
    $('#webUSBHelpDialog').modal('show')
  }
}
